import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { PawPrint, LogOut } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLeads() {
  const navigate = useNavigate();
  const [leads, setLeads] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) { navigate("/admin/login"); return; }
    axios
      .get(`${API}/leads`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setLeads(res.data))
      .catch(() => {
        localStorage.removeItem("admin_token");
        navigate("/admin/login");
      });
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_user");
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#FBF9F5]" data-testid="admin-leads-page">
      <header className="bg-white border-b border-[#E4DFD3]">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 h-[72px] flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <span className="w-9 h-9 rounded-full bg-[#0D3B3E] flex items-center justify-center">
              <PawPrint className="w-5 h-5 text-[#F7C948]" />
            </span>
            <span className="font-display font-extrabold text-lg text-[#0D3B3E]">Franchise Leads</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-sm text-[#5C6B6C] hover:text-[#0D3B3E]" data-testid="admin-leads-back-link">View site</Link>
            <button
              onClick={logout}
              data-testid="admin-logout-button"
              className="inline-flex items-center gap-2 rounded-full bg-[#0D3B3E] text-white text-sm font-semibold px-4 py-2 hover:bg-[#07282A] transition-colors"
            >
              <LogOut className="w-4 h-4" /> Sign Out
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-5 sm:px-8 py-10">
        {leads === null ? (
          <p className="text-[#5C6B6C]" data-testid="admin-leads-loading">Loading leads...</p>
        ) : leads.length === 0 ? (
          <div className="bg-white rounded-3xl border border-[#E4DFD3] p-14 text-center" data-testid="admin-leads-empty">
            <p className="font-display font-bold text-[#0D3B3E] text-lg mb-2">No leads yet</p>
            <p className="text-sm text-[#5C6B6C]">New franchise info requests will appear here.</p>
          </div>
        ) : (
          <div className="bg-white rounded-3xl border border-[#E4DFD3] overflow-hidden" data-testid="admin-leads-table">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-[#E4DFD3] text-left text-xs uppercase tracking-widest text-[#5C6B6C]">
                    <th className="px-6 py-4">Name</th>
                    <th className="px-6 py-4">Contact</th>
                    <th className="px-6 py-4">Market</th>
                    <th className="px-6 py-4">Liquid Capital</th>
                    <th className="px-6 py-4">Net Worth</th>
                    <th className="px-6 py-4">Submitted</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.map((l) => (
                    <tr key={l.id} className="border-b border-[#E4DFD3] last:border-0 hover:bg-[#FBF9F5]" data-testid={`admin-lead-row-${l.id}`}>
                      <td className="px-6 py-4 font-semibold text-[#0D3B3E]">{l.name}</td>
                      <td className="px-6 py-4 text-[#5C6B6C]">{l.email}<br />{l.phone}</td>
                      <td className="px-6 py-4 text-[#5C6B6C]">{l.market}</td>
                      <td className="px-6 py-4 text-[#5C6B6C]">{l.capital_range}</td>
                      <td className="px-6 py-4 text-[#5C6B6C]">{l.net_worth_range}</td>
                      <td className="px-6 py-4 text-[#5C6B6C]">{new Date(l.created_at).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
